<template>
    <div mt-3>
      <v-carousel>
        <v-carousel-item v-for="(item,i) in pics"
          :key="i" :src="item.src">
          </v-carousel-item>
      </v-carousel>
      <v-row>
          <v-col style="'background:src(@/assets/images/Solar.jpg)" cols="12" sm="12" xs="12" md="12">
                <h1 class="text-center">Durability, Perfomance & UserFriendly</h1>
                <div class="mr-3 ml-3 mt-4 mb-4 font-weight-light text-center grey--text darke-5">
                  Investing in solar is a big decision, and not all solar companies are the same. At EquatorSun, we have installed more than tons of solar systems over the years, and we are backed by over 7 years as Uganda's solar energy experts. We always start with a free on-site solar assessment, rigorously test our systems for the harshest Ugandan conditions, and guarantee the performance of every product we sell.
                  <br><br>
                  Most importantly, we offer solar hot water, solar power and battery storage.
                </div>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" xs="4" lg="4" v-for="solar in waterHeatersPreview" :key="solar.message">
            <v-card class="mx-auto  mr-1 ml-1">
              <v-img class="white--text align-end" height="250px" :src="solar.src">
                <v-card-title>{{solar.message}}</v-card-title>
              </v-img>

              <v-card-actions>
                <!-- <router-link to="/Product" tag="span" style="cursor: pointer">
                  <v-btn color="yellow darken-3" text>View Product</v-btn>
                </router-link> -->
              </v-card-actions>
            </v-card>
        </v-col>

      </v-row>

      <v-row>
        <v-col xs4 md4 class="footer white--text text-right font-italic font-weight-light">
            <h2>Ready To Talk?</h2>
        </v-col>
        <v-col xs4 md4 class="footer text-left">
            <router-link to="/Quote" tag="span" style="cursor: pointer">
            <img src="@/assets/images/quote.png">
            </router-link>
        </v-col>
      </v-row>

    </div>
</template>
<script>
export default {
  data () {
    return {
      pics: [
        {
          src: require('@/assets/images/1.jpg'),
          desc: 'Best Heaters Ever ee'
        },
        {
          src: require('@/assets/images/2.jpg'),
          desc: 'Best Heaters Ever33'
        },
        {
          src: require('@/assets/images/pan2.jpg'),
          desc: 'Best Heaters Ever'
        },
        {
          src: require('@/assets/images/Roof.jpg'),
          desc: 'Best Heaters Ever2'
        }
      ],
      waterHeatersPreview: [
        {
          src: require('@/assets/images/1.jpg'),
          message: '220Ltr Tank'
        },
        {
          src: require('@/assets/images/2.jpg'),
          message: 'Solar BackUp Element'
        },
        {
          src: require('@/assets/images/pan1.jpg'),
          message: 'Heater Elements'
        }
      ],
      bgBeta: require('@/assets/images/Solar.jpg')
    }
  }
}
</script>
<style scoped>
  .midWay{
    background-color: #2196F3;
  }
  .footer{
    background: #00529f;
    color: white;
  }
</style>
